import { useState } from "react";
import TypewriterText from "@/components/TypewriterText";

// Renders answer text turning inline [n] citation markers into clickable chips.
// Markers with a matching citation (by .n) become buttons; others stay as text.
function renderAnswer(text, citations, onCite) {
  const byN = {};
  (citations || []).forEach((c) => { if (c?.n != null) byN[c.n] = c; });
  const nodes = [];
  const regex = /\[(\d+)\]/g;
  let last = 0;
  let key = 0;
  let m;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    const n = parseInt(m[1], 10);
    const cit = byN[n];
    if (cit) {
      nodes.push(
        <button
          key={`c${key++}`}
          type="button"
          data-testid={`cite-ref-${n}`}
          onClick={() => onCite(cit)}
          title="Kaynağı gör"
          className="mx-[1px] inline-flex h-[18px] min-w-[18px] -translate-y-[1px] items-center justify-center rounded-[6px] bg-foreground/10 px-1 align-middle text-[11px] font-semibold text-foreground/70 transition-colors hover:bg-foreground hover:text-background"
        >
          {n}
        </button>
      );
    } else {
      nodes.push(m[0]);
    }
    last = regex.lastIndex;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

// Handles the typewriter reveal, then swaps to the clickable-citation render.
export default function AnswerText({ text = "", citations = [], animate = false, onTick, onCite, className = "" }) {
  const [revealed, setRevealed] = useState(!animate);
  return (
    <p className={`whitespace-pre-wrap ${className}`}>
      {animate && !revealed ? (
        <TypewriterText text={text} onTick={onTick} onDone={() => setRevealed(true)} />
      ) : (
        renderAnswer(text, citations, onCite || (() => {}))
      )}
    </p>
  );
}
